import styled from 'styled-components';
import { MaterialIcons } from 'styles/fonts';

export const Icon = styled.b`
    font-family: ${MaterialIcons};
    margin-right: 8px;
    font-weight: normal;
`;
